import {
  LegalClientEntity,
  LegalClientRepresentativeEntity,
} from 'api/types/entity';
import { LoadingLayout } from 'components';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import {
  BackBody,
  OnboardingLayout,
} from 'modules/onboarding/common/components';
import { OnboardingProvider } from 'modules/onboarding/common/providers';

import { useOnboarding } from '../hooks/useOnboarding';
import { pagesMap } from '../route';

interface Props {
  currentClient: LegalClientRepresentativeEntity;
  legalClient: LegalClientEntity;
  id?: string;
  goBack: () => void;
  onCreateHead: (id: string) => void;
}

export const LegalClientHeadContainer = ({
  currentClient,
  legalClient,
  goBack,
  onCreateHead,
  id,
}: Props) => {
  const { loading, process, onGoBack, onEnd, getHead, legalClientHead } =
    useOnboarding(currentClient, legalClient, id);

  const { t } = useTranslation();

  if (loading) {
    return <LoadingLayout />;
  }

  const handleEnd = async () => {
    if (await onEnd()) {
      goBack();
    }
  };

  const handleCreateHead = async (id: string) => {
    await getHead(legalClient.id, id);
    onCreateHead(id);
  };

  return (
    <OnboardingProvider
      clientId={currentClient.id}
      data={{
        currentClient,
        legalClient,
        legalClientHead,
        onCreateHead: handleCreateHead,
      }}
      pagesMap={pagesMap}
      process={legalClientHead?.onboarding?.process ?? process!}
      renderChild={({ route }) => {
        const Component = route.page.component;
        return (
          <OnboardingLayout key={route.pageKey} headerComponent={<div />}>
            <Stack spacing={16}>
              <BackBody
                text={t('onboarding.legalClientHead.backTitle')}
                onClick={goBack}
              />
              <Component {...route.page.componentProps} />
            </Stack>
          </OnboardingLayout>
        );
      }}
      onEnd={handleEnd}
      onGoBack={onGoBack}
    />
  );
};
